import { ChangePasswordPage } from '@/pages/change-password';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/change-password')({
	component: ChangePasswordPage,
});
